import React, { useState, useEffect } from "react";
import { Tab } from "../../../../components/tab";
import Hitory from "./hitory";
import PersonnelPass from "./personnelpass";
import HeaderBar from "../../../../components/header/headerBar";
import MainButton from "../../../../components/button/mainButton";
import Icon from "@mdi/react";
import { mdiPencilOutline } from "@mdi/js";
import { useParams } from "react-router";

interface ParamTypes {
  id: string;
}
const PersonnelCreate = () => {
  const [title, setTitle] = useState("");
  const [isHidel, setIsHidel] = useState<boolean>(true);
  const [tabNumber, setTabNumber] = useState<number>();

  const tabList = [{ title: "ประวัติ" }, { title: "รหัสผ่าน" }];
  const panelList = [
    { panel: <Hitory isHidel={isHidel} /> },
    { panel: <PersonnelPass isHidel={isHidel} /> },
  ];

  useEffect(() => {
    setTitle("CREATE PERSONNEL");
  }, []);

  const { id } = useParams<ParamTypes>();

  console.log("PERSONNEL => ", id);

  const onChangeHide = () => {
    if (tabNumber === 0) {
      setIsHidel(!isHidel);
    } else {
      setIsHidel(!isHidel);
    }
  };

  const onChangeTapState = (index: number) => {
    setTabNumber(index);
    if (index === 0) {
      setTitle("CREATE PERSONNEL");
    } else {
      setTitle("LOGIN INFORMATION");
    }
  };

  return (
    <div>
      <HeaderBar title={title} btnBack={true}>
        {id !== undefined ? (
          <MainButton title="Edit" onClick={onChangeHide}>
            <Icon path={mdiPencilOutline} color="#FFFFFF" size="20" />
          </MainButton>
        ) : undefined}
      </HeaderBar>
      <div style={{ margin: "0px 40px" }}>
        <Tab
          tabList={tabList}
          panelList={panelList}
          onChangeTapState={onChangeTapState}
        />
      </div>
    </div>
  );
};
export default PersonnelCreate;
